// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/calendar_event_status.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/calendar_event_status.proto.
 */
export const file_studyo_today_planners_v1_resources_calendar_event_status = /*@__PURE__*/
  fileDesc("Cj5zdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL2NhbGVuZGFyX2V2ZW50X3N0YXR1cy5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyqrAQoTQ2FsZW5kYXJFdmVudFN0YXR1cxIlCiFDQUxFTkRBUl9FVkVOVF9TVEFUVVNfVU5TUEVDSUZJRUQQABIjCh9DQUxFTkRBUl9FVkVOVF9TVEFUVVNfQ09ORklSTUVEEAESIwofQ0FMRU5EQVJfRVZFTlRfU1RBVFVTX1RFTlRBVElWRRACEiMKH0NBTEVOREFSX0VWRU5UX1NUQVRVU19DQU5DRUxMRUQQA0IqqgInU3R1ZHlvLlRvZGF5LlBsYW5uZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the enum studyo.today.planners.v1.resources.CalendarEventStatus.
 */
export const CalendarEventStatusSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_planners_v1_resources_calendar_event_status, 0);

/**
 * All statuses a calendar event can have.
 *
 * @generated from enum studyo.today.planners.v1.resources.CalendarEventStatus
 */
export const CalendarEventStatus = /*@__PURE__*/
  tsEnum(CalendarEventStatusSchema);

